<template>
  <WrapperForm
    v-model="selectedTab"
    :tabs="tabs"
    :show-stepper="false"
    :tabs-placement="tabsPlacement"
  >
    <router-view :key="route.name" />
  </WrapperForm>
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router'
  import { useNavigationTabs } from './useNavigationTabs.ts'
  type TabsViewProps = {
    tabsPlacement?: 'center' | 'start'
    persistentTabs?: boolean
  }
  const props = withDefaults(defineProps<TabsViewProps>(), { tabsPlacement: 'center', persistentTabs: false })

  const route = useRoute()
  const { tabs, selectedTab } = useNavigationTabs(props.persistentTabs)
</script>
